
const products = [
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FSMALL%2520banner%2520%25286%2529-1e0f689f-0ff5-4bb7-af60-6ce6c83ed89c.png&w=1920&q=75',
    title: "TEC SHOWDOWN SERIES SEASON-4",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "ONGOING",
    date: "20 Sept 2024",
    link: "/xyz-tro-123" , 
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FBIG%2520banner%2520%25286%2529-d778697e-1115-410a-8f0c-1b2da8d55972.png&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' Valorant',
    teamsize:'5-1',
    prize:'1,00,000 INR',
    format:'Single Elimination',
    registerstart:'August 31st, 2024, 12:00 PM',
    registerend:'September 4th, 2024, 4:00 PM',
    tournamentstart:'September 9th, 2024',
    tournamentend:'September 15th, 2024'
    ,id:"1"
  },
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini-Banner%2520%25283%2529-a2932703-0beb-4dee-916c-6adc06d8eca0.png&w=1920&q=75',
    title: "Intel Gamer Days - Lenovo, Valorant 5v5",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "ONGOING",
    date: "20 Sept 2024",
    link: "/xyz-tro-123",
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain-Banner%2520%25285%2529-acda6f20-2ab5-4063-9279-2dcda6234239.png&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' Valorant',
    teamsize:'5-1',
    prize:'20,00,000 INR',
    format:'Single Elimination',
    registerstart:'August 31st, 2024, 12:00 PM',
    registerend:'September 6th, 2024, 4:00 PM',
    tournamentstart:'September 6th, 2024 ,1:00 PM',
    tournamentend:'September 6th, 2024, 6:00 PM'
    ,id:"2"
  },
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FSMALL%2520Banner-8d5477ec-acea-4088-afb2-2d9e9680476a.png&w=1920&q=75',
    title: "MidfailYT Community Clash",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "ONGOING",
    date: "20 Sept 2024",
    link: "/xyz-tro-123",
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FBIG%2520banner-440ac13d-f766-41ec-ad61-55330d2511fc.png&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' Valorant',
    teamsize:'5-1',
    prize:'1,00,000 INR',
    format:'Single Elimination',
    registerstart:'August 31st, 2024, 12:00 PM',
    registerend:'September 4th, 2024, 4:00 PM',
    tournamentstart:'September 9th, 2024',
    tournamentend:'September 15th, 2024'
    ,id:"3"
  },
  {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini%2520Banner%2520%25282%2529-aecc3a6a-0dd3-428f-bd2e-78b218f15535.png&w=1920&q=75',
      title: "Intel Gamer Days - Vishal Peripherals, Telangana (Valorant)",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "100000000",
      participants: "8 of 128",
      status: "ONGOING",
      date: "20 Sept 2024",
      link: "/xyz-tro-123",
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain%2520Banner%2520%25282%2529-7bdf88d6-c2d1-4f6b-a2ae-8ba510187945.png&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:' League of Legends',
      teamsize:'5+2',
      prize:'1,00,000 INR',
      format:'Double Elimination',
      registerstart:'August 31st, 2024, 12:00 PM',
      registerend:'September 18th, 2024, 4:00 PM',
      tournamentstart:'September 18th, 2024,1:00 AM',
      tournamentend:'September 18th, 2024,11:00 PM'
      ,id:"4"

    },
    {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini%2520Banner%2520%25281%2529-6ed796e2-b4bc-45e4-91b0-123853ee12b0.png&w=1920&q=75',
      title: "Intel Gamer Days - Vishal Peripherals, Telangana (EAFC)",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "100000000",
      participants: "8 of 128",
      status: "ONGOING",
      date: "20 Sept 2024",
      link: "/xyz-tro-123" ,
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain%2520Banner%2520%25281%2529-71fc88b7-f8f2-46c0-861c-79f577e82438.png&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:'  EAFC24(1v1)',
      teamsize:'NA',
      prize:'24,000 INR',
      format:'Single Elimination',
      registerstart:'August 31st, 2024, 12:00 PM',
      registerend:'September 4th, 2024, 4:00 PM',
      tournamentstart:'September 9th, 2024',
      tournamentend:'September 15th, 2024'
      ,id:"5"
    },
    {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini%2520Banner-13acf6d1-cf8b-4ce2-b8dc-8872fbc9c5dc.png&w=1920&q=75',
      title: "Intel Gamer Days - Vishal Peripherals, Telangana (MK1)",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "100000000",
      participants: "8 of 128",
      status: "ONGOING",
      date: "20 Sept 2024",
      link: "/xyz-tro-123" ,
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain%2520Banner-f630e498-9b1b-4577-ad90-987db9e25ac1.png&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:' MK1 ',
      teamsize:'NA',
      prize:'1,00,000 INR',
      format:'Single Elimination',
      registerstart:'August 31st, 2024, 12:00 PM',
      registerend:'September 4th, 2024, 4:00 PM',
      tournamentstart:'September 9th, 2024',
      tournamentend:'September 15th, 2024'
      ,id:"6"
    }

];

export{
  products
}